import React from "react";

import { Container } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import "./CompletedPage.css";

const CompletedPage = () => {
  return (
    <Container className="vf-completed">
      <div className="vf-completed-card" role="status" aria-live="polite">
        <div className="vf-completed-card__hero">
          <div className="vf-completed-card__icon-wrapper">
            <FontAwesomeIcon icon={faCircleCheck} className="vf-completed-card__icon" />
          </div>
          <h1 className="vf-completed-card__title">Form Completed</h1>
        </div>
        <div className="vf-completed-card__body">
          <p className="vf-completed-card__lead">
            Your form has been sent to Hafnia for further management.
          </p>
          <p className="vf-completed-card__hint">
            You can safely close this tab. We will reach out if anything else is needed.
          </p>
        </div>
      </div>
    </Container>
  );
};

export default CompletedPage;
